<template>
  <ValidationObserver ref="validator">
    <form novalidate class="md-layout generic-form" @submit.prevent="validate">
      <div class="md-layout-item md-medium-size-100 md-size-100">
        <md-card>
          <md-card-content>
            <div class="md-layout md-gutter">
              <div class="md-layout-item md-size-25 md-small-size-100">
                <md-radio :key="'res'" class="md-layout-item md-size-40 md-small-size-100" v-model="reloadType" :value="'Reservation'">{{
                  'Reservas'
                }}</md-radio>
                <md-radio :key="'inv'" class="md-layout-item md-size-40 md-small-size-100" v-model="reloadType" :value="'Inventory'">{{
                  'Inventario'
                }}</md-radio>
              </div>
              <div class="md-layout-item md-size-30 md-small-size-100">
                <ValidationProvider name="table name" rules="required" v-slot="{ passed, failed, errors }" slim>
                  <md-field :class="[{ 'md-error': failed }, { 'md-invalid': failed }, { 'md-valid': passed }]">
                    <label>PMS type</label>
                    <md-select v-model="reloadDto.pms_name">
                      <md-option :value="'AVALON'">{{ 'Pms Avalon' }}</md-option>
                      <md-option :value="'ENGISOFTlos_action_current'">{{ 'Pms Engisoft' }}</md-option>
                      <md-option :value="'PRESTIGE'">{{ 'Pms Prestige' }}</md-option>
                      <md-option :value="'SIMPLE'">{{ 'Pms Simple' }}</md-option>
                    </md-select>
                    <span :class="[{ 'md-error': failed }]">{{ errors[0] }}</span>
                  </md-field>
                </ValidationProvider>
              </div>
              <div class="md-layout-item md-size-30 md-small-size-100">
                <date-range-picker
                  :start="reloadDto.travel_from"
                  :end="reloadDto.travel_to"
                  @change="changeTravelDate"
                  :min-days="1"
                  :max-days="maxDays"
                  :max-months="3"
                  :displayList="false"
                  :displayFrom="false"
                  :displayTo="false"
                  displayFromTo
                  style="min-width: 250px;"
                />
              </div>
            </div>
            <div class="md-layout md-gutter">
              <div class="md-layout-item md-size-20 md-small-size-100">
                <md-checkbox v-model="pmsReload" class="text-nowrap">
                  Reload From PMS
                </md-checkbox>
              </div>
            </div>
            <div v-if="pmsReload" class="md-layout md-gutter">
              <div class="md-layout-item md-size-25 md-small-size-100">
                <ValidationProvider name="table name" rules="required" v-slot="{ passed, failed, errors }" slim>
                  <md-field :class="[{ 'md-error': failed }, { 'md-invalid': failed }, { 'md-valid': passed }]">
                    <label>PMS type</label>
                    <md-select v-model="reloadDto.request_type">
                      <md-option :value="'MODIFICATION'">{{ 'Modificartion' }}</md-option>
                      <md-option :value="'ARRIVAL'">{{ 'Arrival' }}</md-option>
                    </md-select>
                    <span :class="[{ 'md-error': failed }]">{{ errors[0] }}</span>
                  </md-field>
                </ValidationProvider>
              </div>
              <div v-if="reloadDto.pms_name === 'PRESTIGE'" class="md-layout-item md-size-25 md-small-size-100">
                <ValidationProvider name="table name" rules="required" v-slot="{ passed, failed, errors }" slim>
                  <md-field :class="[{ 'md-error': failed }, { 'md-invalid': failed }, { 'md-valid': passed }]">
                    <label>Elements</label>
                    <md-select v-model="reloadDto.elements" multiple>
                      <md-option :value="'RESERVAS'">{{ 'Reservas' }}</md-option>
                      <md-option :value="'CARDEX'">{{ 'Cardex' }}</md-option>
                      <md-option :value="'CARGOS'">{{ 'Cargos' }}</md-option>
                    </md-select>
                    <span :class="[{ 'md-error': failed }]">{{ errors[0] }}</span>
                  </md-field>
                </ValidationProvider>
              </div>
            </div>
          </md-card-content>
          <md-card-actions>
            <md-button class="md-success" type="submit">Save</md-button>
          </md-card-actions>
        </md-card>
      </div>
    </form>
  </ValidationObserver>
</template>
<script>
import DateRangePicker from '@/components/Inputs/DateRangePicker.vue'

import { ReloadControllerApi } from '@/openapi/src'

var reloadApi = new ReloadControllerApi()

export default {
  components: { DateRangePicker },
  data() {
    return {
      reloadType: 'Reservation',
      reloadDto: {
        tenant_name: null,
        hotel_id: null,
        pms_name: null,
        travel_from: null,
        travel_to: null,
      },
      maxDays: 10,
      pmsReload: false,
    }
  },
  methods: {
    changeTravelDate(range) {
      this.reloadDto.travel_from = range.start
      this.reloadDto.travel_to = range.end
    },
    reload() {
      this.reloadDto.hotel_id = sessionStorage.getItem('hotel')
      this.reloadDto.tenant_name = this.getTenantName()
      if (this.pmsReload) {
        if (this.reloadType === 'Reservation') {
          reloadApi.reloadPmsReservation(this.reloadDto, (error, data) => {})
        } else {
          reloadApi.reloadPmsInventory(this.reloadDto, (error, data) => {})
        }
      } else {
        if (this.reloadType === 'Reservation') {
          reloadApi.reloadReservations(this.reloadDto, (error, data) => {})
        } else {
          reloadApi.reloadInventory(this.reloadDto, (error, data) => {})
        }
      }

      this.$notify({
        timeout: 4500,
        message: 'The Actions was saved shortly',
        icon: 'check_box',
        horizontalAlign: 'right',
        verticalAlign: 'top',
        type: 'info',
      })
    },
    getTenantName() {
      return this.$root.tenantName()
    },
    async validate() {
      const isValid = await this.$refs.validator.validate()
      if (isValid) {
        return this.reload()
      }
    },
  },
}
</script>
<style lang="scss"></style>
